/* ENERVIT kalkulacka vyzivy. Generuje Tools/shopify-admin/enervit_kalkulacka/build.js z engine.js a ui.js. */
/*
 * ENERVIT kalkulacka vyzivy na zavod (25. 10. 2026)
 * -------------------------------------------------
 * Ciste vypocty bez DOM: spocitaj(vstup, moznosti) -> plan, vykresli(plan, jazyk, katalog) -> HTML.
 * Bezi v prehliadaci (window.EnervitKalkulacka) aj v Node (build.js generuje staticke priklady do HTML).
 *
 * Cisla a zdroje (podrobne v obsah/kalkulacka-vyzivy-navrh.md):
 *  - sacharidy za hodinu podla dlzky: ACSM/AND/DC 2016 (do 1 h netreba, 1-2,5 h 30-60 g, nad 2,5 h 60-90 g),
 *    nad 90 g len s natrenovanym zaludkom, najviac 120 g (Morton a kol. 2026), C2:1 = glukoza a fruktoza (Jeukendrup 2010)
 *  - pot 0,5-2 l za hodinu, sodik v pote 0,2-1,6 g/l, priemer 0,8 g/l (Baker 2017)
 *  - pitie: nahradit pot tak, aby ubytok hmotnosti nepresiahol 2 %, a nikdy nepit viac, nez sa vypoti (ACSM 2007,
 *    Hew-Butler 2017); vychodisko 0,4-0,8 l za hodinu
 *  - sodik v tom, co vypijete: 0,46-0,69 g/l ako v sportovom napoji (ACSM 2007, 20-30 mmol/l), pri slanom pote 1 g/l
 *  - pred: 1-4 g/kg 1-4 h pred, carb loading 10-12 g/kg denne 36-48 h pred vykonom nad 90 min (ACSM 2016)
 *  - po: 1,25-1,5 l na kazdy strateny kg (ACSM 2016), bielkoviny po 20-40 g (ISSN 2017)
 *  - produkty: vyzivove udaje na etikete (tabulky v e-shope enervitcz, overene 25. 10. 2026)
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.EnervitKalkulacka = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Hodnoty na jednu davku podla vyzivovych udajov (sodik = sul / 2,5).
  var P = {
    'enervit-carbo-gel-c2-1': { cs: 'Carbo Gel C2:1', sk: 'Carbo Gel C2:1', sach: 40, na: 0,
      fakt: { cs: '40 g sacharidů v 60 ml', sk: '40 g sacharidov v 60 ml' } },
    'enervit-carbo-gel-c2-1-se-sodikem': { cs: 'Carbo Gel C2:1 se sodíkem', sk: 'Carbo Gel C2:1 so sodíkom', sach: 40, na: 200,
      fakt: { cs: '40 g sacharidů a 200 mg sodíku', sk: '40 g sacharidov a 200 mg sodíka' } },
    'enervit-carbo-gel-c2-1-s-kofeinem': { cs: 'Carbo Gel C2:1 s kofeinem', sk: 'Carbo Gel C2:1 s kofeínom', sach: 40, na: 0, kof: 100,
      fakt: { cs: '40 g sacharidů a 100 mg kofeinu', sk: '40 g sacharidov a 100 mg kofeínu' } },
    'enervit-liquid-gel': { cs: 'Liquid Gel', sk: 'Liquid Gel', sach: 30, na: 4,
      fakt: { cs: '30 g sacharidů, tekutější gel', sk: '30 g sacharidov, tekutejší gél' } },
    'enervit-liquid-gel-competition': { cs: 'Liquid Gel Competition s kofeinem', sk: 'Liquid Gel Competition s kofeínom', sach: 30, na: 3, kof: 25,
      fakt: { cs: '30 g sacharidů a 25 mg kofeinu', sk: '30 g sacharidov a 25 mg kofeínu' } },
    'enervit-gel': { cs: 'ENERVIT Gel', sk: 'ENERVIT Gel', sach: 20, na: 10,
      fakt: { cs: '20 g sacharidů v 25 ml', sk: '20 g sacharidov v 25 ml' } },
    'enervit-carbo-jelly-c2-1': { cs: 'Carbo Jelly C2:1', sk: 'Carbo Jelly C2:1', sach: 30, na: 52,
      fakt: { cs: '30 g sacharidů v želé 50 g', sk: '30 g sacharidov v želé 50 g' } },
    'enervit-carbo-chews-c2-1': { cs: 'Carbo Chews C2:1', sk: 'Carbo Chews C2:1', sach: 30, na: 0,
      fakt: { cs: '30 g sacharidů v 6 želatinkách', sk: '30 g sacharidov v 6 želatínkach' } },
    'enervit-carbo-bar-c2-1': { cs: 'Carbo Bar C2:1', sk: 'Carbo Bar C2:1', sach: 30, na: 0,
      fakt: { cs: '30 g sacharidů v tyčince', sk: '30 g sacharidov v tyčinke' } },
    'enervit-carbo-bar-c2-1-se-sodikem': { cs: 'Carbo Bar C2:1 se sodíkem', sk: 'Carbo Bar C2:1 so sodíkom', sach: 30, na: 200,
      fakt: { cs: '30 g sacharidů a 200 mg sodíku', sk: '30 g sacharidov a 200 mg sodíka' } },
    'enervit-competition-bar': { cs: 'Competition Bar', sk: 'Competition Bar', sach: 23, na: 12,
      fakt: { cs: '23 g sacharidů v tyčince 30 g', sk: '23 g sacharidov v tyčinke 30 g' } },
    'enervit-isotonic-drink': { cs: 'Isotonic Drink', sk: 'Isotonic Drink', sach: 25, na: 240, napoj: true,
      davka: { cs: 'dávka 30 g', sk: 'dávka 30 g' },
      fakt: { cs: '25 g sacharidů a 240 mg sodíku v 500 ml', sk: '25 g sacharidov a 240 mg sodíka v 500 ml' } },
    'enervit-isocarb-c2-1': { cs: 'Isocarb C2:1', sk: 'Isocarb C2:1', sach: 60, na: 240, napoj: true,
      davka: { cs: 'sáček 65 g', sk: 'sáčok 65 g' },
      fakt: { cs: '60 g sacharidů a 240 mg sodíku v 500 ml', sk: '60 g sacharidov a 240 mg sodíka v 500 ml' } },
    'enervit-sport-drink': { cs: 'Sport Drink', sk: 'Sport Drink', sach: 13, na: 240, napoj: true,
      davka: { cs: 'sáček 16 g', sk: 'sáčok 16 g' },
      fakt: { cs: '13 g sacharidů a 240 mg sodíku v 500 ml', sk: '13 g sacharidov a 240 mg sodíka v 500 ml' } },
    'enervit-electrolytes-boost': { cs: 'Electrolytes Boost', sk: 'Electrolytes Boost', sach: 0, na: 400, napoj: true,
      davka: { cs: 'sáček 4 g', sk: 'sáčok 4 g' },
      fakt: { cs: '400 mg sodíku v 500 ml, bez sacharidů', sk: '400 mg sodíka v 500 ml, bez sacharidov' } },
    'enervit-salt-caps': { cs: 'Salt Caps', sk: 'Salt Caps', sach: 0, na: 300,
      davka: { cs: '2 kapsle', sk: '2 kapsuly' },
      fakt: { cs: '300 mg sodíku ve 2 kapslích', sk: '300 mg sodíka v 2 kapsulách' } },
    'enervit-pre-sport': { cs: 'PRE Sport', sk: 'PRE Sport', sach: 25.5,
      fakt: { cs: '25,5 g sacharidů v sáčku s pomerančem, 27 g s brusinkou', sk: '25,5 g sacharidov v sáčku s pomarančom, 27 g s brusnicou' } },
    'enervit-recovery-drink': { cs: 'R2 Recovery Drink', sk: 'R2 Recovery Drink', sach: 41,
      fakt: { cs: '41 g sacharidů a 4,4 g bílkovin v dávce 50 g', sk: '41 g sacharidov a 4,4 g bielkovín v dávke 50 g' } },
    'enervit-pure-pro-post-workout-boost': { cs: 'Post-Workout Boost', sk: 'Post-Workout Boost', sach: 40,
      fakt: { cs: '40 g sacharidů a 20 g bílkovin v sáčku 65 g', sk: '40 g sacharidov a 20 g bielkovín v sáčku 65 g' } },
    'enervit-hydration': { cs: 'Hydration', sk: 'Hydration', sach: 5, na: 200, jenCz: true,
      fakt: { cs: '200 mg sodíku v plechovce 250 ml', sk: '200 mg sodíka v plechovke 250 ml' } }
  };

  // Ked produkt nie je skladom (alebo na trhu), vezme sa prvy dostupny z nahrad.
  var NAHRADY = {
    'enervit-carbo-gel-c2-1': ['enervit-liquid-gel', 'enervit-carbo-jelly-c2-1', 'enervit-gel'],
    'enervit-liquid-gel': ['enervit-carbo-gel-c2-1', 'enervit-gel'],
    'enervit-carbo-gel-c2-1-se-sodikem': ['enervit-carbo-gel-c2-1', 'enervit-liquid-gel'],
    'enervit-carbo-gel-c2-1-s-kofeinem': ['enervit-liquid-gel-competition', 'enervit-carbo-gel-c2-1'],
    'enervit-liquid-gel-competition': ['enervit-carbo-gel-c2-1-s-kofeinem', 'enervit-liquid-gel'],
    'enervit-carbo-bar-c2-1': ['enervit-carbo-jelly-c2-1', 'enervit-carbo-chews-c2-1', 'enervit-competition-bar'],
    'enervit-carbo-bar-c2-1-se-sodikem': ['enervit-carbo-bar-c2-1', 'enervit-carbo-jelly-c2-1'],
    'enervit-isocarb-c2-1': ['enervit-isotonic-drink', 'enervit-sport-drink'],
    'enervit-isotonic-drink': ['enervit-sport-drink', 'enervit-isocarb-c2-1'],
    'enervit-electrolytes-boost': [],
    'enervit-salt-caps': [],
    'enervit-recovery-drink': ['enervit-pure-pro-post-workout-boost'],
    'enervit-pure-pro-post-workout-boost': ['enervit-recovery-drink'],
    'enervit-hydration': ['enervit-electrolytes-boost']
  };

  var VYCHOZI = { sport: 'beh', minuty: 210, intenzita: 'zavod', teplota: 'mirne', poceni: 'stredne', slany: false,
    zaludek: 'do60', hmotnost: 70, kofein: true };

  // Predvolby dlzky podla sportu (minuty).
  var PREDVOLBY = {
    beh: [['10 km', 50], [{ cs: 'Půlmaraton', sk: 'Polmaratón' }, 110], [{ cs: 'Maraton', sk: 'Maratón' }, 210], ['Ultra', 360]],
    kolo: [['2 h', 120], ['3 h', 180], ['4 h', 240], ['6 h', 360]],
    triatlon: [['Sprint', 75], [{ cs: 'Olympijský', sk: 'Olympijský' }, 150], ['70.3', 330], ['Ironman', 660]],
    bezky: [['25 km', 105], ['50 km', 210], ['70 km', 300]]
  };

  var POT = { malo: 0.5, stredne: 1.0, hodne: 1.5 };            // l/h pri beznom treningu v miernom pocasi
  var POT_TEPLOTA = { chladno: -0.25, mirne: 0, teplo: 0.25, horko: 0.5 };
  var POT_INTENZITA = { lehka: -0.25, stredni: 0, zavod: 0.25 };
  var NA_V_POTE = 0.8;      // g/l, priemer (Baker 2017)
  var NA_V_POTE_SLANY = 1.2;
  var NA_V_PITI = { chladno: 0.5, mirne: 0.5, teplo: 0.7, horko: 0.7 };   // g/l, ACSM 2007 (20-30 mmol/l = 0,46-0,69 g/l)
  var NA_V_PITI_SLANY = 1.0;
  var NA_TOLERANCIA = 150;  // mg, mensi zvysok pokryje jedlo a pitie na trati
  var BEH_MAX = 90;         // g/h pri behu aj s natrenovanym zaludkom (ACSM 2016)
  var BIDON = 0.5;          // l
  var SALT_CAPS_MAX = 3;    // davky po 2 kapsle = 6 kapsli denne (etiketa)
  var TRIATLON = { plavani: 0.15, kolo: 0.5, beh: 0.35 };       // orientacne rozdelenie casu

  function zaokr(x, krok) { return Math.round(x / krok) * krok; }
  function medzi(x, a, b) { return Math.max(a, Math.min(b, x)); }

  function dostupny(h, opt) {
    if (opt.trh === 'sk' && P[h] && P[h].jenCz) return false;
    if (!opt.dostupne) return true;
    return opt.dostupne.indexOf(h) !== -1;
  }
  function vyber(h, opt) {
    if (dostupny(h, opt)) return h;
    var n = NAHRADY[h] || [];
    for (var i = 0; i < n.length; i++) if (dostupny(n[i], opt)) return n[i];
    return null;
  }

  function sacharidyZaHodinu(v) {
    var m = v.minuty;
    var idx = { lehka: 0, stredni: 1, zavod: 2 }[v.intenzita];
    var r;
    if (m <= 60) return { cil: 0, rozsah: [0, 0], obmedzene: false };
    if (m <= 150) r = { rozsah: [30, 60], ciel: [30, 45, 60][idx] };
    else {
      var vytrval = v.sport === 'kolo' || v.sport === 'triatlon';
      if (v.zaludek === 'nad90' && vytrval) r = { rozsah: [60, 120], ciel: [60, 90, 120][idx] };
      else r = { rozsah: [60, 90], ciel: [60, 75, 90][idx] };
    }
    var strop = { do60: 60, do90: 90, nad90: 120 }[v.zaludek] || 60;
    return { cil: Math.min(r.ciel, strop), rozsah: r.rozsah, obmedzene: r.ciel > strop };
  }

  // Rovnomerne rozlozene casy davok od `od` po `do` (minuty od startu).
  function casy(n, od, doMin) {
    if (n <= 0) return [];
    if (n === 1) return [zaokr(Math.min(od, doMin), 5)];
    var krok = (doMin - od) / (n - 1);
    var out = [];
    for (var i = 0; i < n; i++) out.push(zaokr(od + krok * i, 5));
    return out;
  }

  function spocitaj(vstup, moznosti) {
    var v = {};
    for (var k in VYCHOZI) v[k] = VYCHOZI[k];
    for (var k2 in vstup) if (vstup[k2] !== undefined && vstup[k2] !== null && vstup[k2] !== '') v[k2] = vstup[k2];
    v.minuty = medzi(Math.round(Number(v.minuty) || 0), 20, 900);
    v.hmotnost = medzi(Math.round(Number(v.hmotnost) || 70), 35, 150);
    var opt = { trh: (moznosti && moznosti.trh) || 'cz', dostupne: (moznosti && moznosti.dostupne) || null };

    var hodiny = v.minuty / 60;
    var s = sacharidyZaHodinu(v);

    // Pot a pitie
    var pot = medzi(POT[v.poceni] + POT_TEPLOTA[v.teplota] + POT_INTENZITA[v.intenzita], 0.3, 2.0);
    var pitieHodiny = v.sport === 'triatlon' ? hodiny * (1 - TRIATLON.plavani) : hodiny;
    var povolenaStrata = 0.02 * v.hmotnost;                       // kg = l
    var pit = pot - povolenaStrata / pitieHodiny;
    pit = Math.min(pot, Math.max(Math.min(pot, 0.4), pit));
    pit = zaokr(pit, 0.05);
    var strata = Math.max(0, (pot - pit) * pitieHodiny);          // kg po vykone (odhad)

    // Sodik
    var potrebaNa = v.minuty > 120 || (v.minuty > 60 && (v.teplota === 'teplo' || v.teplota === 'horko' || v.slany));
    var naH = potrebaNa ? zaokr(pit * (v.slany ? NA_V_PITI_SLANY : NA_V_PITI[v.teplota]) * 1000, 50) : 0;
    var teplo = v.teplota === 'teplo' || v.teplota === 'horko' || v.slany;
    var naStrataH = zaokr(pot * (v.slany ? NA_V_POTE_SLANY : NA_V_POTE) * 1000, 50);
    var naCelkom = zaokr(naH * pitieHodiny, 50);

    var plan = {
      vstup: v, trh: opt.trh, hodiny: hodiny,
      sacharidy: { cil: s.cil, rozsah: s.rozsah, obmedzene: s.obmedzene, celkem: Math.round(s.cil * hodiny) },
      pot: pot, pit: pit, strata: strata,
      sodik: { potreba: potrebaNa, h: naH, strataH: naStrataH, celkem: naCelkom, pokryte: 0, zvysok: 0 },
      pred: [], behem: [], pitie: null, po: [], nakup: {}, tipy: []
    };

    // Kofein len v zavode od 60 minut
    var kofein = !!v.kofein && v.intenzita === 'zavod' && v.minuty >= 60;

    function pridaj(min, h, pocet, kluc, data) {
      if (!h) return;
      plan.behem.push({ min: min, h: h, pocet: pocet || 1, kluc: kluc || '', data: data || {} });
      plan.nakup[h] = (plan.nakup[h] || 0) + (pocet || 1);
    }

    // ---------- PRED ----------
    if (v.minuty <= 60) {
      plan.pred.push({ kluc: 'jidlo_kratke' });
    } else {
      if (v.minuty > 90 && v.intenzita === 'zavod') {
        plan.pred.push({ kluc: 'carb_loading', data: { od: 10 * v.hmotnost, do: 12 * v.hmotnost } });
      }
      plan.pred.push({ kluc: 'jidlo', data: { od: 1 * v.hmotnost, do: 4 * v.hmotnost } });
      var pre = vyber('enervit-pre-sport', opt);
      if (pre && (v.intenzita !== 'lehka' || v.minuty > 120)) { plan.pred.push({ kluc: 'pre_sport', h: pre }); plan.nakup[pre] = (plan.nakup[pre] || 0) + 1; }
    }

    // ---------- POCAS ----------
    var naZostava = naCelkom;
    var naZdroje = 0;

    // Behove casti (beh, bezky, beh v triatlone): gely v pravidelnych intervaloch
    function behovaCast(start, dlzka, sacharidyCast, jeBezky, zNapoja) {
      var koniec = start + dlzka;
      var hlavny = vyber('enervit-carbo-gel-c2-1', opt);
      if (!hlavny || sacharidyCast <= 0) return { gely: [] };
      var tycinky = [];
      var zvysok = sacharidyCast - (zNapoja || 0);
      if (jeBezky && dlzka > 150) {
        var bar = vyber('enervit-carbo-bar-c2-1', opt);
        if (bar) { tycinky.push({ min: start + zaokr(dlzka * 0.4, 5), h: bar }); zvysok -= P[bar].sach; }
      }
      var n = zvysok > 0 ? Math.max(1, Math.round(zvysok / P[hlavny].sach)) : 0;
      var prvy = start === 0 ? (dlzka >= 75 ? 35 : zaokr(dlzka / 2, 5)) : start + 10;
      var posledny = Math.max(prvy, koniec - 15);
      var t = casy(n, prvy, posledny);
      var gely = t.map(function (m) { return { min: m, h: hlavny }; });
      tycinky.forEach(function (x) { gely.push(x); });
      gely.sort(function (a, b) { return a.min - b.min; });
      return { gely: gely, hlavny: hlavny };
    }

    function kofeinNaZaver(gely, celkoveMinuty) {
      if (!kofein || !gely.length) return;
      var kofH = vyber(celkoveMinuty >= 120 ? 'enervit-carbo-gel-c2-1-s-kofeinem' : 'enervit-liquid-gel-competition', opt);
      if (!kofH) return;
      var pocet = celkoveMinuty >= 240 && P[kofH].kof >= 100 ? 2 : 1;   // Carbo Gel C2:1 s kofeinem nejvys 2 za vykon
      var gelove = gely.filter(function (g) { return !/bar|jelly|chews/.test(g.h); });
      for (var i = 0; i < pocet && i < gelove.length; i++) {
        gelove[gelove.length - 1 - i].h = kofH;
        gelove[gelove.length - 1 - i].kof = true;
      }
    }

    // Sodik doplni nahradou gelov/tyciniek za verziu so sodikom, potom Salt Caps.
    function sodikDoGelov(polozky) {
      if (!potrebaNa) return;
      for (var i = polozky.length - 1; i >= 0 && naZostava >= 100; i--) {
        var g = polozky[i];
        if (g.kof) continue;
        var nova = null;
        if (g.h === 'enervit-carbo-gel-c2-1' || g.h === 'enervit-liquid-gel') nova = vyber('enervit-carbo-gel-c2-1-se-sodikem', opt);
        if (g.h === 'enervit-carbo-bar-c2-1') nova = vyber('enervit-carbo-bar-c2-1-se-sodikem', opt);
        if (nova && P[nova].na > P[g.h].na) {
          naZostava -= P[nova].na - P[g.h].na; naZdroje += P[nova].na - P[g.h].na; g.h = nova;
        }
      }
    }
    function sodikKapsle(start, dlzka) {
      if (!potrebaNa || !teplo || naZostava <= NA_TOLERANCIA) return;
      var caps = vyber('enervit-salt-caps', opt);
      if (!caps) return;
      var n = Math.min(SALT_CAPS_MAX, Math.ceil(naZostava / P[caps].na), Math.max(1, Math.floor(dlzka / 60)));
      var t = casy(n, start + 60 <= start + dlzka - 15 ? start + 60 : start + zaokr(dlzka / 2, 5), start + dlzka - 30);
      t.forEach(function (m) { pridaj(m, caps, 1, 'kapsle'); naZostava -= P[caps].na; naZdroje += P[caps].na; });
    }

    function zapisGely(gely) {
      gely.forEach(function (g) { pridaj(g.min, g.h, 1, g.kof ? 'kofein' : (/bar/.test(g.h) ? 'tycinka' : 'gel')); });
    }

    // Cyklisticke casti (kolo, kolo v triatlone): bidony, tycinky v prvej polovici, gely v druhej
    function kolovaCast(start, dlzka, sacharidyCast, hodinyCast) {
      var bidony = Math.max(sacharidyCast > 0 || dlzka > 60 ? 1 : 0, Math.round(pit * hodinyCast / BIDON));
      var napoj = null, sNapoj = 0, nNapoj = 0;
      if (sacharidyCast > 0) {
        napoj = vyber(plan.sacharidy.cil > 75 ? 'enervit-isocarb-c2-1' : 'enervit-isotonic-drink', opt);
        if (napoj) {
          nNapoj = Math.min(bidony, Math.max(1, Math.floor(sacharidyCast * 2 / 3 / P[napoj].sach)));
          sNapoj = nNapoj * P[napoj].sach;
        }
      }
      var voda = bidony - nNapoj;
      var nEb = 0;
      if (napoj) { naZostava -= nNapoj * P[napoj].na; naZdroje += nNapoj * P[napoj].na; }
      var eb = vyber('enervit-electrolytes-boost', opt);
      if (potrebaNa && eb && voda > 0 && naZostava > 0) {
        nEb = Math.min(voda, Math.ceil(naZostava / P[eb].na), Math.max(1, Math.round(hodinyCast)));   // [OVERIT] denna davka EB
        naZostava -= nEb * P[eb].na; naZdroje += nEb * P[eb].na;
      }
      var interval = bidony > 0 ? zaokr(dlzka / bidony, 5) : 0;
      plan.pitie = { bidony: bidony, interval: interval, voda: voda - nEb, napoj: napoj, nNapoj: nNapoj, eb: nEb ? eb : null, nEb: nEb };
      plan.behem.push({ min: start, h: null, pocet: bidony, kluc: 'bidony', data: plan.pitie });
      if (napoj) plan.nakup[napoj] = (plan.nakup[napoj] || 0) + nNapoj;
      if (nEb) plan.nakup[eb] = (plan.nakup[eb] || 0) + nEb;

      var zvysok = Math.max(0, sacharidyCast - sNapoj);
      var polozky = [];
      if (zvysok > 0) {
        var bar = dlzka > 90 ? vyber('enervit-carbo-bar-c2-1', opt) : null;
        var gel = vyber('enervit-carbo-gel-c2-1', opt);
        var nBar = bar ? Math.round(zvysok / 2 / P[bar].sach) : 0;
        var nGel = gel ? Math.max(0, Math.round((zvysok - nBar * (bar ? P[bar].sach : 0)) / P[gel].sach)) : 0;
        if (!gel && bar) nBar = Math.max(1, Math.round(zvysok / P[bar].sach));
        casy(nBar, start + 45, start + dlzka * 0.5).forEach(function (m) { polozky.push({ min: m, h: bar }); });
        // jeden gel patri do zaveru, viac gelov rovnomerne v druhej polovici
        var odGel = nGel === 1 ? Math.max(45, dlzka - 45) : Math.max(45, zaokr(dlzka * 0.55, 5));
        casy(nGel, start + odGel, start + dlzka - 15).forEach(function (m) { polozky.push({ min: m, h: gel }); });
      }
      return polozky;
    }

    if (s.cil === 0) {
      plan.pitie = { len_voda: true };
      if (v.intenzita === 'zavod' && v.minuty >= 45) plan.tipy.push('kratky_zavod');
    } else if (v.sport === 'beh' || v.sport === 'bezky') {
      // iontovy napoj na obcerstvovackach (beh) alebo z termosky (bezky): polovica pitia, 240 mg sodiku na 500 ml
      var ion = vyber('enervit-isotonic-drink', opt);
      var nIon = ion ? Math.max(1, Math.round(pit * hodiny / 2 / BIDON)) : 0;
      var sIon = v.sport === 'bezky' && ion ? nIon * P[ion].sach : 0;   // z termosky vieme, kolko vypije
      if (potrebaNa && ion) {
        var naIon = zaokr(pit * hodiny / 2 / BIDON * P[ion].na, 10);
        naZostava -= naIon; naZdroje += naIon;
        plan.pitie = { ionty_polovica: true, na: naIon };
      }
      if (v.sport === 'bezky' && ion) { plan.nakup[ion] = (plan.nakup[ion] || 0) + nIon; plan.pitie = plan.pitie || { ionty_polovica: true, na: 0 }; plan.pitie.sach = sIon; plan.pitie.nIon = nIon; }
      var b = behovaCast(0, v.minuty, plan.sacharidy.celkem, v.sport === 'bezky', sIon);
      kofeinNaZaver(b.gely, v.minuty);
      sodikDoGelov(b.gely);
      zapisGely(b.gely);
      sodikKapsle(0, v.minuty);
    } else if (v.sport === 'kolo') {
      var pol = kolovaCast(0, v.minuty, plan.sacharidy.celkem, hodiny);
      kofeinNaZaver(pol, v.minuty);
      sodikDoGelov(pol);
      zapisGely(pol);
      sodikKapsle(0, v.minuty);
    } else if (v.sport === 'triatlon') {
      var tPlav = zaokr(v.minuty * TRIATLON.plavani, 5);
      var tKolo = zaokr(v.minuty * TRIATLON.kolo, 5);
      var tBeh = v.minuty - tPlav - tKolo;
      var sKolo = Math.round(s.cil * tKolo / 60);
      var sBeh = Math.round(Math.min(s.cil, BEH_MAX) * tBeh / 60);
      plan.casti = { plavani: tPlav, kolo: tKolo, beh: tBeh };
      var polK = kolovaCast(tPlav, tKolo, sKolo, tKolo / 60);
      var behT = behovaCast(tPlav + tKolo, tBeh, sBeh, false);
      kofeinNaZaver(behT.gely, v.minuty);
      sodikDoGelov(polK.concat(behT.gely));
      zapisGely(polK);
      zapisGely(behT.gely);
      sodikKapsle(tPlav, tKolo);
      plan.sacharidy.celkem = sKolo + sBeh;
    }
    plan.behem.sort(function (a, b) { return a.min - b.min; });
    plan.sodik.pokryte = Math.max(0, zaokr(naZdroje, 10));
    plan.sodik.zvysok = potrebaNa && naZostava > NA_TOLERANCIA ? zaokr(naZostava, 50) : 0;

    // Sacharidy, ktore plan naozaj dava (kontrola)
    var dane = 0;
    plan.behem.forEach(function (x) { if (P[x.h]) dane += (P[x.h].sach || 0) * x.pocet; });
    if (plan.pitie && plan.pitie.napoj) dane += P[plan.pitie.napoj].sach * plan.pitie.nNapoj;
    if (plan.pitie && plan.pitie.sach) dane += plan.pitie.sach;
    plan.sacharidy.zplanu = dane;

    // ---------- PO ----------
    if (strata >= 0.3) plan.po.push({ kluc: 'tekutiny', data: { kg: strata, od: strata * 1.25, do: strata * 1.5 } });
    else plan.po.push({ kluc: 'tekutiny_malo' });
    if (v.minuty >= 90 || (v.minuty >= 60 && v.intenzita !== 'lehka')) {
      var r2 = vyber('enervit-recovery-drink', opt), pwb = vyber('enervit-pure-pro-post-workout-boost', opt);
      if (r2 || pwb) {
        plan.po.push({ kluc: 'sacharidy_bilkoviny', h: r2, h2: pwb && pwb !== r2 ? pwb : null });
        plan.nakup[r2 || pwb] = (plan.nakup[r2 || pwb] || 0) + 1;
      }
    }
    if (potrebaNa || strata >= 1) {
      var hyd = vyber('enervit-hydration', opt);
      plan.po.push({ kluc: 'sodik_po', h: hyd });
    }

    // ---------- TIPY ----------
    if (s.obmedzene) plan.tipy.push('zaludek');
    if (s.cil > 90) plan.tipy.push('nad90');
    if (v.teplota === 'chladno') plan.tipy.push('zima');
    if (v.teplota === 'horko') plan.tipy.push('horko');
    if (pit > 1) plan.tipy.push('vela_pitia');
    if (plan.sodik.zvysok > 0) plan.tipy.push('sodik_zvysok');
    if (plan.nakup['enervit-salt-caps']) plan.tipy.push('salt_caps');
    if (kofein && plan.behem.some(function (x) { return x.kluc === 'kofein'; })) plan.tipy.push('kofein');
    if (v.sport === 'triatlon') plan.tipy.push('triatlon');
    plan.tipy.push('vyskusat');
    plan.tipy.push('neprepijat');
    return plan;
  }

  // ---------------------------------------------------------------- TEXTY A VYKRESLENIE
  var T = {
    cs: {
      sport: { beh: 'běh', kolo: 'kolo', triatlon: 'triatlon', bezky: 'běžky' },
      intenzita: { lehka: 'lehce', stredni: 'středně', zavod: 'závod' },
      teplota: { chladno: 'pod 10 °C', mirne: '10 až 20 °C', teplo: '20 až 25 °C', horko: 'nad 25 °C' },
      poceni: { malo: 'potím se málo', stredne: 'potím se průměrně', hodne: 'potím se hodně' },
      souhrn_h: 'Váš plán', zaHodinu: 'za hodinu',
      k_sach: 'sacharidů', k_pit: 'tekutin', k_na: 'sodíku',
      celkem: 'celkem', neni_nutne: 'není nutné', podle_zizne: 'podle žízně',
      pred: 'Před výkonem', behem: 'Během výkonu', po: 'Po výkonu', nakup: 'Co si připravit', tipy: 'Na co myslet',
      start: 'start', cil_txt: 'cíl',
      pred_txt: {
        jidlo_kratke: 'Snídaně nebo běžné jídlo 2 až 4 hodiny před startem, víc nepotřebujete.',
        carb_loading: '1 až 2 dny před závodem: 10 až 12 g sacharidů na kg denně, pro vás {od} až {do} g (těstoviny, rýže, pečivo, brambory).',
        jidlo: '1 až 4 hodiny před startem: jídlo se sacharidy, 1 až 4 g na kg, pro vás {od} až {do} g. Čím blíž startu, tím menší porce s menším množstvím tuku a vlákniny.',
        pre_sport: '60 až 120 minut před startem: {p}, 1 až 2 sáčky ({f}).'
      },
      gel: 'zapít vodou', tycinka: 'v klidnějším úseku', kofein: 'kofein na závěr',
      kapsle: 'zapít vodou',
      bidony: 'Bidony po 500 ml: {n}, jeden zhruba každých {i} minut.',
      bidon_s: '{n}× s {p} ({f})', bidon_voda: '{n}× čistá voda',
      pitie_beh: 'Pijte průběžně asi {l} l za hodinu, tedy zhruba {ml} ml každých 15 minut.',
      pitie_obcerstvovacky: 'Na občerstvovačkách střídejte vodu a iontový nápoj, z něj máte asi {na} mg sodíku.',
      pitie_bezky: 'Iontový nápoj si namíchejte do termosky do vlažné vody, polovinu pití můžete mít z něj (asi {na} mg sodíku).',
      pitie_voda: 'Pijte vodu podle žízně a počasí. Do hodiny sacharidy obvykle nepotřebujete.',
      plavani: 'plavání', kolo_cast: 'kolo', beh_cast: 'běh',
      po_txt: {
        tekutiny: 'Odhadem ztratíte asi {kg} kg. Postupně vypijte {od} až {do} l, tedy 1,25 až 1,5 l na každý kilogram. Přesně to zjistíte vážením před výkonem a po něm.',
        tekutiny_malo: 'Doplňte tekutiny podle žízně. Pokud vážíte méně než před výkonem, vypijte 1,25 až 1,5 l na každý ztracený kilogram.',
        sacharidy_bilkoviny: 'Do 30 minut sacharidy a bílkoviny: {p} ({f}){alt}.',
        sacharidy_bilkoviny_alt: ', nebo {p} ({f})',
        sodik_po: 'K jídlu přidejte něco slaného{alt}.',
        sodik_po_alt: ', nebo {p} ({f})'
      },
      tip: {
        zaludek: 'Plán je omezený na tolik sacharidů za hodinu, kolik máte vyzkoušeno. Na víc si zvykněte postupně na trénincích, víc v článku <a href="/blogs/clanky/trenink-zaludku">Trénink žaludku</a>.',
        nad90: 'Nad 90 g za hodinu jdou jen sportovci s natrénovaným žaludkem. Přehled studií z roku 2026 uvádí až 120 g za hodinu, vyšší dávky výzkum zatím nepotvrdil.',
        zima: 'V mrazu gel houstne, noste ho ve vnitřní kapse. Pijte průběžně, i když nemáte žízeň.',
        horko: 'V horku pijte od prvních minut a sodík doplňujte průběžně, ne až na konci.',
        vela_pitia: 'Víc než litr za hodinu se dá vypít jen po troškách. Vyzkoušejte si to na tréninku, a co nevypijete, doplňte po výkonu.',
        sodik_zvysok: 'Zbývá asi {mg} mg sodíku. Doplňte ho iontovým nápojem nebo slaným jídlem na trati.',
        salt_caps: 'Salt Caps zapijte vodou, nejvýš 6 kapslí denně.',
        kofein: 'Produkty s kofeinem nejsou vhodné pro děti, těhotné a kojící ženy. Carbo Gel C2:1 s kofeinem nejvýš 2 za výkon a započítejte i kávu.',
        triatlon: 'Čas plavání, kola a běhu je odhad (15, 50 a 35 % času). Nejvíc sacharidů doplníte na kole, kde se jí a pije snáz.',
        vyskusat: 'Všechno vyzkoušejte na tréninku, ne poprvé na závodě.',
        neprepijat: 'Nepijte víc, než vypotíte. Když po výkonu vážíte víc než před ním, pili jste příliš.',
        kratky_zavod: 'Na závod do hodiny gel obvykle nepotřebujete. V horku si dejte pár doušků iontového nápoje.'
      },
      ks: '×', gramu: 'g', z_planu: 'Z produktů v plánu {g} g sacharidů.',
      odhad_potu: 'Odhad potu: {l} l za hodinu, s potem ztratíte asi {na} mg sodíku za hodinu.',
      sodik_neni: 'Sodík navíc není nutný, stačí jídlo a pití.',
      sodik_txt: 'Sodík: asi {h} mg za hodinu, celkem {c} mg.',
      nakup_txt: 'Na tento výkon budete potřebovat',
      nakup_konf: 'Produkty si můžete vybrat i podle příchutě a přidat do košíku ve <a href="/pages/konfigurator">Výživě na míru</a>.',
      odkaz: 'Zobrazit produkt'
    },
    sk: {
      sport: { beh: 'beh', kolo: 'bicykel', triatlon: 'triatlon', bezky: 'bežky' },
      intenzita: { lehka: 'ľahko', stredni: 'stredne', zavod: 'preteky' },
      teplota: { chladno: 'pod 10 °C', mirne: '10 až 20 °C', teplo: '20 až 25 °C', horko: 'nad 25 °C' },
      poceni: { malo: 'potím sa málo', stredne: 'potím sa priemerne', hodne: 'potím sa veľa' },
      souhrn_h: 'Váš plán', zaHodinu: 'za hodinu',
      k_sach: 'sacharidov', k_pit: 'tekutín', k_na: 'sodíka',
      celkem: 'spolu', neni_nutne: 'nie je nutné', podle_zizne: 'podľa smädu',
      pred: 'Pred výkonom', behem: 'Počas výkonu', po: 'Po výkone', nakup: 'Čo si pripraviť', tipy: 'Na čo myslieť',
      start: 'štart', cil_txt: 'cieľ',
      pred_txt: {
        jidlo_kratke: 'Raňajky alebo bežné jedlo 2 až 4 hodiny pred štartom, viac nepotrebujete.',
        carb_loading: '1 až 2 dni pred pretekmi: 10 až 12 g sacharidov na kg denne, pre vás {od} až {do} g (cestoviny, ryža, pečivo, zemiaky).',
        jidlo: '1 až 4 hodiny pred štartom: jedlo so sacharidmi, 1 až 4 g na kg, pre vás {od} až {do} g. Čím bližšie k štartu, tým menšia porcia s menším množstvom tuku a vlákniny.',
        pre_sport: '60 až 120 minút pred štartom: {p}, 1 až 2 sáčky ({f}).'
      },
      gel: 'zapiť vodou', tycinka: 'v pokojnejšom úseku', kofein: 'kofeín na záver',
      kapsle: 'zapiť vodou',
      bidony: 'Bidóny po 500 ml: {n}, jeden zhruba každých {i} minút.',
      bidon_s: '{n}× s {p} ({f})', bidon_voda: '{n}× čistá voda',
      pitie_beh: 'Pite priebežne asi {l} l za hodinu, teda zhruba {ml} ml každých 15 minút.',
      pitie_obcerstvovacky: 'Na občerstvovačkách striedajte vodu a iontový nápoj, z neho máte asi {na} mg sodíka.',
      pitie_bezky: 'Iontový nápoj si namiešajte do termosky do vlažnej vody, polovicu pitia môžete mať z neho (asi {na} mg sodíka).',
      pitie_voda: 'Pite vodu podľa smädu a počasia. Do hodiny sacharidy zvyčajne nepotrebujete.',
      plavani: 'plávanie', kolo_cast: 'bicykel', beh_cast: 'beh',
      po_txt: {
        tekutiny: 'Odhadom stratíte asi {kg} kg. Postupne vypite {od} až {do} l, teda 1,25 až 1,5 l na každý kilogram. Presne to zistíte vážením pred výkonom a po ňom.',
        tekutiny_malo: 'Doplňte tekutiny podľa smädu. Ak vážite menej ako pred výkonom, vypite 1,25 až 1,5 l na každý stratený kilogram.',
        sacharidy_bilkoviny: 'Do 30 minút sacharidy a bielkoviny: {p} ({f}){alt}.',
        sacharidy_bilkoviny_alt: ', alebo {p} ({f})',
        sodik_po: 'K jedlu pridajte niečo slané{alt}.',
        sodik_po_alt: ', alebo {p} ({f})'
      },
      tip: {
        zaludek: 'Plán je obmedzený na toľko sacharidov za hodinu, koľko máte vyskúšané. Na viac si zvyknite postupne na tréningoch, viac v článku <a href="/blogs/clanky/trenink-zaludku">Tréning žalúdka</a>.',
        nad90: 'Nad 90 g za hodinu idú len športovci s natrénovaným žalúdkom. Prehľad štúdií z roku 2026 uvádza až 120 g za hodinu, vyššie dávky výskum zatiaľ nepotvrdil.',
        zima: 'V mraze gél hustne, noste ho vo vnútornom vrecku. Pite priebežne, aj keď nie ste smädní.',
        horko: 'V horúčave pite od prvých minút a sodík dopĺňajte priebežne, nie až na konci.',
        vela_pitia: 'Viac ako liter za hodinu sa dá vypiť len po troškách. Vyskúšajte si to na tréningu, a čo nevypijete, doplňte po výkone.',
        sodik_zvysok: 'Zostáva asi {mg} mg sodíka. Doplňte ho iontovým nápojom alebo slaným jedlom na trati.',
        salt_caps: 'Salt Caps zapite vodou, najviac 6 kapsúl denne.',
        kofein: 'Produkty s kofeínom nie sú vhodné pre deti, tehotné a dojčiace ženy. Carbo Gel C2:1 s kofeínom najviac 2 za výkon a započítajte aj kávu.',
        triatlon: 'Čas plávania, bicykla a behu je odhad (15, 50 a 35 % času). Najviac sacharidov doplníte na bicykli, kde sa je a pije ľahšie.',
        vyskusat: 'Všetko vyskúšajte na tréningu, nie prvýkrát na pretekoch.',
        neprepijat: 'Nepite viac, ako vypotíte. Keď po výkone vážite viac ako pred ním, pili ste príliš.',
        kratky_zavod: 'Na preteky do hodiny gél zvyčajne nepotrebujete. V horúčave si dajte pár dúškov iontového nápoja.'
      },
      ks: '×', gramu: 'g', z_planu: 'Z produktov v pláne {g} g sacharidov.',
      odhad_potu: 'Odhad potu: {l} l za hodinu, s potom stratíte asi {na} mg sodíka za hodinu.',
      sodik_neni: 'Sodík navyše nie je nutný, stačí jedlo a pitie.',
      sodik_txt: 'Sodík: asi {h} mg za hodinu, spolu {c} mg.',
      nakup_txt: 'Na tento výkon budete potrebovať',
      nakup_konf: 'Produkty si môžete vybrať aj podľa príchute a pridať do košíka v konfigurátore <a href="/pages/konfigurator">Výživa na mieru</a>.',
      odkaz: 'Zobraziť produkt'
    }
  };

  function cislo(x, des) {
    var s = (des ? x.toFixed(des) : String(Math.round(x)));
    s = s.replace('.', ',');
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
  function l(x) { var r = Math.round(x * 100) / 100; return cislo(r, Math.round(r * 100) % 10 ? 2 : 1); }
  function cas(min) { var h = Math.floor(min / 60), m = min % 60; return h + ':' + (m < 10 ? '0' : '') + m; }
  function f(t, d) { return t.replace(/\{(\w+)\}/g, function (_, k) { return d[k] !== undefined ? d[k] : ''; }); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function nazov(h, jazyk, katalog) {
    var n = P[h] ? P[h][jazyk] : h;
    var url = (katalog && katalog[h] && katalog[h].url) || ('/products/' + h);
    return '<a href="' + esc(url) + '">' + esc(n) + '</a>';
  }
  function fakt(h, jazyk) { return P[h] && P[h].fakt ? P[h].fakt[jazyk] : ''; }

  function vykresli(plan, jazyk, katalog) {
    var t = T[jazyk] || T.cs;
    var v = plan.vstup;
    var out = [];
    var sach = plan.sacharidy;

    out.push('<div class="ekv-cisla">');
    out.push('<div class="ekv-cislo"><span class="ekv-cislo__v">' + (sach.cil ? cislo(sach.cil) + ' g' : t.neni_nutne) +
      '</span><span class="ekv-cislo__p">' + t.k_sach + ' ' + t.zaHodinu + '</span>' +
      (sach.cil ? '<span class="ekv-cislo__c">' + t.celkem + ' ' + cislo(sach.celkem) + ' g</span>' : '') + '</div>');
    out.push('<div class="ekv-cislo"><span class="ekv-cislo__v">' + (plan.pitie && plan.pitie.len_voda ? t.podle_zizne : l(plan.pit) + ' l') +
      '</span><span class="ekv-cislo__p">' + t.k_pit + ' ' + t.zaHodinu + '</span>' +
      (plan.pitie && plan.pitie.len_voda ? '' : '<span class="ekv-cislo__c">' + t.celkem + ' ' + l(zaokr(plan.pit * plan.hodiny * (v.sport === 'triatlon' ? 0.85 : 1), 0.1)) + ' l</span>') + '</div>');
    out.push('<div class="ekv-cislo"><span class="ekv-cislo__v">' + (plan.sodik.potreba ? cislo(plan.sodik.h) + ' mg' : t.neni_nutne) +
      '</span><span class="ekv-cislo__p">' + t.k_na + ' ' + t.zaHodinu + '</span>' +
      (plan.sodik.potreba ? '<span class="ekv-cislo__c">' + t.celkem + ' ' + cislo(plan.sodik.celkem) + ' mg</span>' : '') + '</div>');
    out.push('</div>');
    out.push('<p class="ekv-pozn">' + f(t.odhad_potu, { l: l(plan.pot), na: cislo(plan.sodik.strataH) }) + '</p>');

    // PRED
    out.push('<div class="ekv-faza"><h3>' + t.pred + '</h3><ul>');
    plan.pred.forEach(function (p) {
      var d = p.data || {};
      out.push('<li>' + f(t.pred_txt[p.kluc], { od: cislo(d.od || 0), do: cislo(d.do || 0), p: p.h ? nazov(p.h, jazyk, katalog) : '', f: p.h ? fakt(p.h, jazyk) : '' }) + '</li>');
    });
    out.push('</ul></div>');

    // POCAS
    out.push('<div class="ekv-faza"><h3>' + t.behem + '</h3>');
    if (plan.casti) {
      out.push('<p class="ekv-pozn">' + t.plavani + ' ' + cas(0) + '–' + cas(plan.casti.plavani) + ' · ' + t.kolo_cast + ' ' +
        cas(plan.casti.plavani) + '–' + cas(plan.casti.plavani + plan.casti.kolo) + ' · ' + t.beh_cast + ' ' +
        cas(plan.casti.plavani + plan.casti.kolo) + '–' + cas(v.minuty) + '</p>');
    }
    if (plan.pitie && plan.pitie.len_voda) out.push('<p>' + t.pitie_voda + '</p>');
    out.push('<ol class="ekv-os">');
    plan.behem.forEach(function (x) {
      var text;
      if (x.kluc === 'bidony') {
        var d = x.data, sklad = [];
        if (d.napoj) sklad.push(f(t.bidon_s, { n: d.nNapoj, p: nazov(d.napoj, jazyk, katalog), f: fakt(d.napoj, jazyk) }));
        if (d.eb) sklad.push(f(t.bidon_s, { n: d.nEb, p: nazov(d.eb, jazyk, katalog), f: fakt(d.eb, jazyk) }));
        if (d.voda > 0) sklad.push(f(t.bidon_voda, { n: d.voda }));
        text = f(t.bidony, { n: d.bidony, i: d.interval }) + (sklad.length ? '<br><span class="ekv-fakt">' + sklad.join(', ') + '</span>' : '');
      } else text = nazov(x.h, jazyk, katalog) + ' <span class="ekv-fakt">' + fakt(x.h, jazyk) + (t[x.kluc] ? ', ' + t[x.kluc] : '') + '</span>';
      out.push('<li><span class="ekv-cas">' + cas(x.min) + '</span><span>' + text + '</span></li>');
    });
    out.push('</ol>');
    if (!(plan.pitie && plan.pitie.len_voda)) {
      out.push('<p>' + f(t.pitie_beh, { l: l(plan.pit), ml: cislo(zaokr(plan.pit * 250, 25)) }) + '</p>');
      if (plan.pitie && plan.pitie.ionty_polovica) out.push('<p>' + f(v.sport === 'bezky' ? t.pitie_bezky : t.pitie_obcerstvovacky, { na: cislo(plan.pitie.na) }) + '</p>');
      out.push('<p>' + (plan.sodik.potreba ? f(t.sodik_txt, { h: cislo(plan.sodik.h), c: cislo(plan.sodik.celkem) }) : t.sodik_neni) + '</p>');
    }
    out.push('</div>');

    // PO
    out.push('<div class="ekv-faza"><h3>' + t.po + '</h3><ul>');
    plan.po.forEach(function (p) {
      var d = p.data || {};
      var alt = '';
      if (p.kluc === 'sacharidy_bilkoviny' && p.h2) alt = f(t.po_txt.sacharidy_bilkoviny_alt, { p: nazov(p.h2, jazyk, katalog), f: fakt(p.h2, jazyk) });
      if (p.kluc === 'sodik_po' && p.h) alt = f(t.po_txt.sodik_po_alt, { p: nazov(p.h, jazyk, katalog), f: fakt(p.h, jazyk) });
      var h1 = p.kluc === 'sacharidy_bilkoviny' ? (p.h || p.h2) : null;
      out.push('<li>' + f(t.po_txt[p.kluc], { kg: l(zaokr(d.kg || 0, 0.1)), od: l(zaokr(d.od || 0, 0.1)), do: l(zaokr(d.do || 0, 0.1)), p: h1 ? nazov(h1, jazyk, katalog) : '', f: h1 ? fakt(h1, jazyk) : '', alt: alt }) + '</li>');
    });
    out.push('</ul></div>');

    // NAKUP
    var hs = Object.keys(plan.nakup);
    if (hs.length) {
      out.push('<div class="ekv-faza ekv-nakup"><h3>' + t.nakup + '</h3><p>' + t.nakup_txt + ':</p><ul class="ekv-produkty">');
      hs.forEach(function (h) {
        var k = katalog && katalog[h];
        var img = k && k.img ? '<img src="' + esc(k.img) + '" alt="" width="64" height="64" loading="lazy">' : '';
        var davka = P[h] && P[h].davka ? ' (' + P[h].davka[jazyk] + ')' : '';
        out.push('<li>' + img + '<span><strong>' + plan.nakup[h] + '× ' + nazov(h, jazyk, katalog) + '</strong>' + davka +
          '<br><span class="ekv-fakt">' + fakt(h, jazyk) + '</span></span></li>');
      });
      out.push('</ul><p>' + t.nakup_konf + '</p></div>');
    }

    // TIPY
    out.push('<div class="ekv-faza ekv-tipy"><h3>' + t.tipy + '</h3><ul>');
    plan.tipy.forEach(function (k) { out.push('<li>' + f(t.tip[k], { mg: cislo(plan.sodik.zvysok) }) + '</li>'); });
    out.push('</ul></div>');
    return out.join('');
  }

  // Jedna veta zhrnutia (pre staticke priklady a meta)
  function veta(plan, jazyk) {
    var t = T[jazyk] || T.cs;
    var s = plan.sacharidy;
    var casti = [];
    casti.push(s.cil ? cislo(s.cil) + ' g ' + t.k_sach + ' ' + t.zaHodinu : t.k_sach + ': ' + t.neni_nutne);
    casti.push(plan.pitie && plan.pitie.len_voda ? (jazyk === 'sk' ? 'voda podľa smädu' : 'voda podle žízně') : l(plan.pit) + ' l ' + t.k_pit);
    if (plan.sodik.potreba) casti.push(cislo(plan.sodik.h) + ' mg ' + t.k_na);
    return casti.join(', ');
  }

  return { P: P, NAHRADY: NAHRADY, VYCHOZI: VYCHOZI, PREDVOLBY: PREDVOLBY, T: T,
    spocitaj: spocitaj, vykresli: vykresli, veta: veta, cas: cas, cislo: cislo };
});

/*
 * ENERVIT kalkulacka vyzivy: ovladanie formulara v prehliadaci. build.js ho spoji s engine.js do
 * assets/enervit-kalkulacka.js. Formular a staticky priklad planu su v HTML sekcie (citatelne bez JS),
 * tento skript ich len prepocita a doplni obrazky produktov z katalogu sekcie (len produkty skladom na danom trhu).
 */
(function () {
  'use strict';
  var E = window.EnervitKalkulacka;
  if (!E) return;
  Array.prototype.forEach.call(document.querySelectorAll('[data-ekv]'), init);

  // Cookie lista Pandectes je modal v hornej vrstve s inline display:block !important, CSS ju pri tlaci neskryje.
  // Na cas tlace ju skryjeme a potom vratime povodny styl.
  var cmpStyl = null;
  window.addEventListener('beforeprint', function () {
    var c = document.querySelector('pandectes-cmp');
    if (c) { cmpStyl = c.getAttribute('style'); c.style.setProperty('display', 'none', 'important'); }
  });
  window.addEventListener('afterprint', function () {
    var c = document.querySelector('pandectes-cmp');
    if (c && cmpStyl !== null) { c.setAttribute('style', cmpStyl); cmpStyl = null; }
  });

  function init(root) {
  var jazyk = root.getAttribute('data-jazyk') === 'sk' ? 'sk' : 'cs';
  var trh = root.getAttribute('data-trh') === 'sk' ? 'sk' : 'cz';
  var katalog = {};
  try { katalog = JSON.parse((root.querySelector('[data-ekv-katalog]') || {}).textContent || '{}'); } catch (e) { katalog = {}; }
  var dostupne = Object.keys(katalog).filter(function (h) { return katalog[h] && katalog[h].ok; });

  var form = root.querySelector('[data-ekv-form]');
  var vysledok = root.querySelector('[data-ekv-vysledok]');
  var nadpis = root.querySelector('[data-ekv-nadpis]');
  var poznamka = root.querySelector('[data-ekv-priklad]');
  var predvolby = root.querySelector('[data-ekv-predvolby]');
  var rozsah = form.querySelector('input[name="minuty"]');
  var casVystup = root.querySelector('[data-ekv-cas]');
  var T = E.T[jazyk];

  // Parametre v adrese: ?sport=beh&min=210&int=zavod&tep=mirne&pot=stredne&slany=1&kg=70&zal=do60&kof=0
  var MAPA = { sport: 'sport', min: 'minuty', int: 'intenzita', tep: 'teplota', pot: 'poceni', slany: 'slany', kg: 'hmotnost', zal: 'zaludek', kof: 'kofein' };

  function nastav(nazov, hodnota) {
    var pole = form.elements[nazov];
    if (!pole) return;
    if (pole.type === 'checkbox') { pole.checked = hodnota === true || hodnota === '1'; return; }
    if (pole.length && pole[0] && pole[0].type === 'radio') {
      for (var i = 0; i < pole.length; i++) pole[i].checked = pole[i].value === String(hodnota);
      return;
    }
    pole.value = hodnota;
  }

  function hodnota(nazov) {
    var pole = form.elements[nazov];
    if (!pole) return undefined;
    if (pole.type === 'checkbox') return pole.checked;
    if (pole.length && pole[0] && pole[0].type === 'radio') {
      for (var i = 0; i < pole.length; i++) if (pole[i].checked) return pole[i].value;
      return undefined;
    }
    return pole.value;
  }

  function vstup() {
    return {
      sport: hodnota('sport'), minuty: Number(hodnota('minuty')), intenzita: hodnota('intenzita'),
      teplota: hodnota('teplota'), poceni: hodnota('poceni'), slany: hodnota('slany'),
      hmotnost: Number(hodnota('hmotnost')), zaludek: hodnota('zaludek'), kofein: hodnota('kofein')
    };
  }

  function casText(min) {
    var h = Math.floor(min / 60), m = min % 60;
    return (h ? h + ' ' + (jazyk === 'sk' ? 'h' : 'h') : '') + (h && m ? ' ' : '') + (m || !h ? m + ' min' : '');
  }

  function vykresliPredvolby() {
    var sport = hodnota('sport') || 'beh';
    var min = Number(hodnota('minuty'));
    predvolby.innerHTML = '';
    (E.PREDVOLBY[sport] || []).forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ekv-cip' + (p[1] === min ? ' is-on' : '');
      b.textContent = (typeof p[0] === 'string' ? p[0] : p[0][jazyk]) + ' · ' + E.cas(p[1]);
      b.setAttribute('aria-pressed', p[1] === min ? 'true' : 'false');
      b.addEventListener('click', function () { rozsah.value = p[1]; prepocitaj(true); });
      predvolby.appendChild(b);
    });
  }

  function prepocitaj(ulozit) {
    var v = vstup();
    var plan = E.spocitaj(v, { trh: trh, dostupne: dostupne.length ? dostupne : null });
    casVystup.textContent = casText(plan.vstup.minuty);
    vykresliPredvolby();
    nadpis.textContent = T.souhrn_h + ': ' + T.sport[plan.vstup.sport] + ', ' + E.cas(plan.vstup.minuty) + ', ' + T.intenzita[plan.vstup.intenzita];
    // Odkaz na kalkulacku tempa (cielovy cas) len pri behu
    Array.prototype.forEach.call(root.querySelectorAll('[data-ekv-len-beh]'), function (el) { el.hidden = plan.vstup.sport !== 'beh'; });
    vysledok.innerHTML = E.vykresli(plan, jazyk, katalog);
    if (poznamka) poznamka.hidden = true;
    if (ulozit && !root.hasAttribute('data-ekv-bez-adresy') && window.history && history.replaceState) {
      var q = new URLSearchParams();
      Object.keys(MAPA).forEach(function (k) {
        var x = v[MAPA[k]];
        if (typeof x === 'boolean') x = x ? '1' : '0';
        if (x !== undefined && x !== '') q.set(k, x);
      });
      history.replaceState(null, '', location.pathname + '?' + q.toString() + '#kalkulacka');
    }
  }

  // Stav z adresy
  var q = new URLSearchParams(location.search);
  var zAdresy = false;
  Object.keys(MAPA).forEach(function (k) { if (q.has(k)) { nastav(MAPA[k], q.get(k)); zAdresy = true; } });

  form.addEventListener('change', function () { prepocitaj(true); });
  rozsah.addEventListener('input', function () { casVystup.textContent = casText(Number(rozsah.value)); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    prepocitaj(true);
    var ciel = root.querySelector('.ekv-vysledok');
    if (ciel && ciel.scrollIntoView) ciel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var tlacTisk = root.querySelector('[data-ekv-tisk]');
  if (tlacTisk) tlacTisk.addEventListener('click', function () { window.print(); });
  var tlacOdkaz = root.querySelector('[data-ekv-odkaz]');
  if (tlacOdkaz) tlacOdkaz.addEventListener('click', function () {
    prepocitaj(true);
    var hotovo = function () { var p = tlacOdkaz.textContent; tlacOdkaz.textContent = tlacOdkaz.getAttribute('data-hotovo'); setTimeout(function () { tlacOdkaz.textContent = p; }, 2000); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(location.href).then(hotovo, hotovo);
    else hotovo();
  });

  // Tlac: predkovia vysledku dostanu data-ekv-tlac, CSS pri tlaci skryje vsetko ostatne (styl.css, @media print)
  for (var el = root.querySelector('.ekv-vysledok').parentElement; el && el !== document.body; el = el.parentElement) {
    el.setAttribute('data-ekv-tlac', '');
  }
  root.classList.add('is-js');
  prepocitaj(zAdresy);
  }
})();
